import * as React from 'react';
import { useParams } from 'react-router-dom';

import { CheckoutOrderFragment } from '@websky/graphql';
import { Mode } from '../../../../RetrieveBooking/components/RetrieveBooking';
import { GroupOrderParamsProps } from './types';
import { useTheme } from '../../../../theme';
import { useFindOrder } from './FindOrder.hook';
import RetrieveBooking from '../../../../RetrieveBooking';
import GroupOrder from '../GroupOrder/GroupOrder';
import SecureAccess from '../../../../SecureAccess/SecureAccess';

export interface Props {
	initialId?: string;
	callSubmit?: boolean;
	onSuccess: (order: CheckoutOrderFragment, replace?: boolean) => void;
}

const FindOrder: React.FC<Props> = props => {
	const { initialId, onSuccess, callSubmit } = props;
	const { FindOrder: css } = useTheme('Checkout');

	const { id, secret } = useParams<GroupOrderParamsProps>();

	const model = useFindOrder(props);

	return (
		<>
			<SecureAccess
				isOpen={model.secureAccess.isOpen}
				showError={!model.isLoading && model.secureAccess.showEror}
				isLoading={model.isLoading}
				onSubmit={model.onSubmitSecureAccess}
				onResend={model.onResendSecureAccess}
			/>

			{model.groupOrderResponse ? (
				<GroupOrder
					groupOrder={model.groupOrderResponse}
					onSuccess={order => onSuccess(order as CheckoutOrderFragment, false)}
					onAccept={model.onAcceptGroupOrder}
					setGroupOrder={model.setGroupOrderResponse}
					groupOrderParams={model.groupOrderParams}
				/>
			) : (
				<div className={css.wrapper}>
					<RetrieveBooking
						mode={Mode.Checkout}
						initialId={id ?? initialId}
						initialSecret={secret}
						orderPreview={model.orderPreview}
						submitWithInitialValues={id && secret && callSubmit}
						onSubmit={model.onFindOrder}
						onHideOrderPreview={model.onHideOrderPreview}
						withBookingPreview={model.isAuthorized}
						isOrderOwner={model.isOrderOwner}
					/>
				</div>
			)}
		</>
	);
};

export default FindOrder;
